module.exports = __webpack_public_path__ + "img/gff.4e867d66.png";